import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// File: /home/ubuntu/avaai_dashboard/frontend/src/pages/Settings.tsx
import { fetchCachedAuthUser } from "../utils/authCache";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
import { usePreferences, } from "../context/PreferencesContext";
import { getAvaaioUiCopy, } from "../utils/avaaioUiCopy";
const Settings = () => {
    const navigate = useNavigate();
    const { themeColors } = useContext(ThemeContext);
    const { preferences } = usePreferences();
    const interfaceCopy = getAvaaioUiCopy(preferences.language);
    const [me, setMe] = useState(null);
    useEffect(() => {
        let cancelled = false;
        fetchCachedAuthUser("/api/v1/auth/me", { credentials: "include" })
            .then((data) => {
            if (cancelled || !data)
                return;
            setMe(data?.user ?? data);
        })
            .catch(() => { });
        return () => {
            cancelled = true;
        };
    }, []);
    const role = String(me?.role || "").toLowerCase();
    const sub = String(me?.subscription_status || "").toLowerCase();
    const isAdmin = ["admin", "owner", "superadmin"].includes(role);
    const isPro = role === "vip" || sub === "active";
    const isFree = me ? !isAdmin && !isPro : true;
    const cards = [
        {
            title: interfaceCopy.settings.cards.profile.title,
            subtitle: interfaceCopy.settings.cards.profile.subtitle,
            path: "/profile",
            icon: "👤",
            glow: "rgba(0, 255, 255, 0.28)",
        },
        {
            title: interfaceCopy.settings.cards.system.title,
            subtitle: interfaceCopy.settings.cards.system.subtitle,
            path: "/system",
            icon: "🛡️",
            glow: "rgba(0, 255, 180, 0.24)",
        },
        {
            title: interfaceCopy.settings.cards.account.title,
            subtitle: interfaceCopy.settings.cards.account.subtitle,
            path: "/account",
            icon: "🔐",
            glow: "rgba(0, 210, 255, 0.26)",
        },
        {
            title: interfaceCopy.settings.cards.language.title,
            subtitle: interfaceCopy.settings.cards.language.subtitle,
            path: "/language",
            icon: "🌐",
            glow: "rgba(70, 210, 255, 0.28)",
        },
        {
            title: interfaceCopy.settings.cards.help.title,
            subtitle: interfaceCopy.settings.cards.help.subtitle,
            path: "/info",
            icon: "🧭",
            glow: "rgba(120, 210, 255, 0.28)",
        },
        {
            title: interfaceCopy.settings.cards.support.title,
            subtitle: interfaceCopy.settings.cards.support.subtitle,
            path: "/support",
            icon: "💬",
            glow: "rgba(255, 120, 160, 0.24)",
        },
        {
            title: interfaceCopy.settings.cards.theme.title,
            subtitle: isFree
                ? interfaceCopy.settings.cards.theme.freeSubtitle
                : interfaceCopy.settings.cards.theme.subtitle,
            path: "/theme",
            // // locked: isFree,
            icon: "🎨",
            glow: "rgba(140, 110, 255, 0.28)",
        },
        {
            title: interfaceCopy.settings.cards.entertainment.title,
            subtitle: interfaceCopy.settings.cards.entertainment.subtitle,
            path: "/entertainment",
            icon: "🎬",
            glow: "rgba(255, 90, 200, 0.22)",
        },
        {
            title: interfaceCopy.settings.cards.games.title,
            subtitle: interfaceCopy.settings.cards.games.subtitle,
            path: "/games",
            icon: "🎮",
            glow: "rgba(255, 190, 80, 0.22)",
        },
        {
            title: interfaceCopy.settings.cards.education.title,
            subtitle: interfaceCopy.settings.cards.education.subtitle,
            path: "/education",
            icon: "🎓",
            glow: "rgba(0, 255, 170, 0.28)",
        },
    ];
    const pageStyle = {
        minHeight: "100vh",
        width: "100%",
        boxSizing: "border-box",
        padding: "20px 16px 28px",
        background: "radial-gradient(circle at top, rgba(0,255,255,0.08) 0%, rgba(0,255,255,0.02) 24%, transparent 46%), linear-gradient(180deg, #02050b 0%, #040912 48%, #010203 100%)",
        color: themeColors.text,
        overflowX: "hidden",
        fontFamily: "Orbitron, sans-serif",
    };
    const shellStyle = {
        maxWidth: "1380px",
        margin: "0 auto",
    };
    const heroStyle = {
        borderRadius: "26px",
        padding: "22px 20px 18px",
        marginBottom: "18px",
        background: "linear-gradient(180deg, rgba(8,14,24,0.92) 0%, rgba(4,8,16,0.96) 100%)",
        border: "1px solid rgba(0,255,255,0.12)",
        boxShadow: "0 0 24px rgba(0,255,255,0.08), inset 0 0 18px rgba(255,255,255,0.02)",
        backdropFilter: "blur(12px)",
    };
    const gridStyle = {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        gap: "16px",
    };
    const cardStyle = {
        width: "100%",
        minHeight: "148px",
        borderRadius: "22px",
        padding: "18px 18px 16px",
        textAlign: "left",
        cursor: "pointer",
        background: "linear-gradient(180deg, rgba(10,16,28,0.96) 0%, rgba(5,10,18,0.98) 100%)",
        color: themeColors.text,
        border: "1px solid rgba(90,220,255,0.14)",
        boxShadow: "0 10px 28px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.03)",
        transition: "transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease, background 0.16s ease, opacity 0.16s ease",
    };
    const footerBarStyle = {
        marginTop: "18px",
        display: "flex",
        justifyContent: "center",
    };
    const backButtonStyle = {
        minHeight: "48px",
        borderRadius: "14px",
        padding: "0 18px",
        border: `1px solid ${themeColors.accent}`,
        background: "rgba(6, 14, 24, 0.92)",
        color: themeColors.text,
        fontWeight: 800,
        fontSize: "14px",
        cursor: "pointer",
        boxShadow: "0 0 16px rgba(0,255,255,0.12)",
        letterSpacing: "0.03em",
    };
    function applyHover(e, glow, disabled) {
        if (disabled)
            return;
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.borderColor = "rgba(110, 235, 255, 0.34)";
        e.currentTarget.style.boxShadow = `0 14px 30px rgba(0,0,0,0.34), 0 0 18px ${glow}`;
        e.currentTarget.style.background =
            "linear-gradient(180deg, rgba(12,20,34,0.98) 0%, rgba(6,12,22,1) 100%)";
    }
    function clearHover(e, disabled) {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.borderColor = disabled
            ? "rgba(140,140,140,0.12)"
            : "rgba(90,220,255,0.14)";
        e.currentTarget.style.boxShadow = disabled
            ? "0 10px 24px rgba(0,0,0,0.22), inset 0 1px 0 rgba(255,255,255,0.02)"
            : "0 10px 28px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.03)";
        e.currentTarget.style.background = disabled
            ? "linear-gradient(180deg, rgba(14,18,26,0.96) 0%, rgba(8,12,18,0.98) 100%)"
            : "linear-gradient(180deg, rgba(10,16,28,0.96) 0%, rgba(5,10,18,0.98) 100%)";
    }
    function isPremiumLocked(card) {
        return (isFree &&
            ["/entertainment", "/games", "/education", "/theme"].includes(card.path));
    }
    function handleCardClick(card) {
        if (isPremiumLocked(card)) {
            window.dispatchEvent(new CustomEvent("ava-toast", {
                detail: interfaceCopy.settings.lockedNotice,
            }));
            return;
        }
        if (card.path === "/support") {
            navigate("/support", {
                state: { supportContext: "settings" },
            });
            return;
        }
        navigate(card.path);
    }
    return (_jsx("div", { style: pageStyle, children: _jsxs("div", { style: shellStyle, children: [_jsxs("section", { style: heroStyle, children: [_jsx("div", { style: {
                                fontSize: "11px",
                                letterSpacing: "0.24em",
                                textTransform: "uppercase",
                                color: "#79f3ff",
                                fontWeight: 800,
                                marginBottom: "8px",
                            }, children: interfaceCopy.settings.eyebrow }), _jsx("h1", { style: {
                                margin: 0,
                                fontSize: "clamp(34px, 6vw, 68px)",
                                lineHeight: 1,
                                fontWeight: 900,
                                color: "#19e6ff",
                                textShadow: "0 0 18px rgba(0,255,255,0.18)",
                                letterSpacing: "0.04em",
                            }, children: interfaceCopy.settings.title }), _jsx("p", { style: {
                                marginTop: "12px",
                                marginBottom: 0,
                                maxWidth: "860px",
                                color: "rgba(236,250,255,0.78)",
                                fontSize: "15px",
                                lineHeight: 1.6,
                            }, children: interfaceCopy.settings.subtitle })] }), _jsx("section", { style: gridStyle, children: cards.map((card) => {
                        const isLocked = isPremiumLocked(card);
                        const isDisabled = Boolean(card.disabled || isLocked);
                        return (_jsxs("button", { type: "button", style: {
                                ...cardStyle,
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                opacity: isLocked ? 0.72 : isDisabled ? 0.72 : 1,
                                border: isDisabled
                                    ? "1px solid rgba(140,140,140,0.12)"
                                    : cardStyle.border,
                                background: isDisabled
                                    ? "linear-gradient(180deg, rgba(14,18,26,0.96) 0%, rgba(8,12,18,0.98) 100%)"
                                    : cardStyle.background,
                            }, onClick: (e) => {
                                if (isDisabled) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return;
                                }
                                handleCardClick(card);
                            }, onMouseEnter: (e) => applyHover(e, card.glow, isDisabled), onMouseLeave: (e) => clearHover(e, isDisabled), "aria-disabled": isDisabled, children: [_jsx("div", { style: {
                                        width: "52px",
                                        height: "52px",
                                        borderRadius: "16px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "26px",
                                        marginBottom: "14px",
                                        background: isDisabled
                                            ? "linear-gradient(180deg, rgba(180,180,180,0.12) 0%, rgba(255,255,255,0.04) 100%)"
                                            : "linear-gradient(180deg, rgba(30,220,255,0.18) 0%, rgba(255,255,255,0.05) 100%)",
                                        boxShadow: `0 0 16px ${card.glow}`,
                                    }, children: card.icon }), _jsxs("div", { style: {
                                        fontSize: "20px",
                                        fontWeight: 800,
                                        letterSpacing: "0.03em",
                                        marginBottom: "8px",
                                        color: isDisabled ? "rgba(243,255,255,0.86)" : "#f3ffff",
                                    }, children: [card.title, " ", isLocked && "🔒"] }), _jsx("div", { style: {
                                        fontSize: "13px",
                                        lineHeight: 1.6,
                                        color: isDisabled
                                            ? "rgba(236,250,255,0.58)"
                                            : "rgba(236,250,255,0.72)",
                                    }, children: card.subtitle })] }, card.title));
                    }) }), _jsx("div", { style: footerBarStyle })] }) }));
};
export default Settings;
